<template>

<v-container class="fill-height black" fluid  >
    <div class="h5p-container" style="width: 99%; height: 99%; box-sizing: content-box" ref="h5p-preview"></div>
</v-container>

</template>

<script>



import ShuttleMixins from '@/mixins/ShuttleMixins.js';

  export default {
    name: 'ShuttlePublic',
    mixins:[ShuttleMixins],
    props: {
      source: String,
    },
    data: () => ({


    }),
    created () {
      this.$vuetify.theme.dark = true;

        
        
        
    },

    mounted () {

      //this.loadTranscript();

      this.loadH5p();
       
    },

    methods:{

     loadH5p(){

      var shuttle_id = this.$route.params.id;


        var vm = this;
        (function($) {
              $(function() {
                ////console.log(vm.default_context_json)
                $('.h5p-container').h5p({
                  frameJs: '/js/h5p-standalone-frame.js',
                  frameCss: '/styles/h5p.css',
                  h5pContent: '/h5p_packages/' + shuttle_id,
                  libraryPath: vm.$store.state.uri.h5p_library,
                  //contentOverride: vm.$store.state.default_context_json,
                  //h5pOverride: vm.$store.state.uri.h5p_json_default
                });
              });
            })(H5P.jQuery);



      },


    loadTranscript(){

        
      this.$axios
      .get('/data/transcript.json')
      .then(response => (this.info = response))
          
      },


      loadPresenter(num){

        //console.log('PRESENTER ' + num);

        document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].seek(Object.keys(document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].bookmarksMap)[num]);
        document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].play();

      },

      videoSeek(num){

        //console.log('seek ' + num);

        document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].seek(num);
        document.getElementsByClassName('h5p-iframe')[0].contentWindow.H5P.instances[0].play();
        this.question_dialog = false;

      }



    }






  }






</script>
    <style>
        .*, ::before ::after {
            box-sizing: border-box;
            display: block;
        }
    </style>

